import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "text-4xl font-bold font-chakra text-secondary flex flex-col justify-center items-center invisible",
  ref: "heading"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!

  return (_openBlock(), _createElementBlock("h2", _hoisted_1, [
    (_ctx.icon)
      ? (_openBlock(), _createBlock(_component_FontAwesomeIcon, {
          key: 0,
          icon: _ctx.icon,
          class: "mb-4"
        }, null, 8, ["icon"]))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "default")
  ], 512))
}